<template>
  <table v-if="blok.table" class="blok-table">
    <caption v-if="caption" v-html="caption"></caption>
    <thead>
      <th v-for="(item, index) in blok.table.thead" :key="index">
        {{ item }}
      </th>
    </thead>
    <tbody>
      <tr v-for="(row, index) in blok.table.tbody" :key="index">
        <td v-for="(cell, index) in row" :key="index" v-html="convertMarkdown(cell)"></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import Marked from 'marked'

export default {
  name: 'blok-table',
  props: ['blok'],
  computed: {
    caption() {
      return this.blok.caption ? Marked(this.blok.caption) : ''
    },
  },
  methods: {
    convertMarkdown(markdown) {
      return Marked(markdown)
    },
  },
}
</script>

<style scoped>
table {
  border-collapse: collapse;
  border: 1px solid black;
  margin-bottom: 2rem;
}

tr,
th,
td {
  border: 1px solid black;
}
th {
  background-color: #218fc0;
  color: white;
  padding: 10px 20px;
}
td {
  padding: 10px 20px;
}
caption {
  caption-side: bottom;
  margin-top: 10px;
}
</style>
